import { ExternalLicensePoolScreen } from "./external-license-pool.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const ExternalLicensePoolRoutes: RouteDefinition[] = [
	{
		path: Paths.externalLicensePools.withIdPlaceholder().path,
		element: <ExternalLicensePoolScreen />,
		requiredPermissions: ["UserInAccountPermission_ExternalLicenseAdmin_Read"],
	},
];
